import { touchRippleClasses } from "@mui/material";

export function validarCNPJ(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '');

  if (cnpj === '') return false;

  if (cnpj.length !== 14) return false;

  const numerosRepetidos = '00000000000000 11111111111111 22222222222222 33333333333333 44444444444444 55555555555555 66666666666666 77777777777777 88888888888888 99999999999999';
  if (numerosRepetidos.indexOf(cnpj) !== -1) return false;

  let tamanho = cnpj.length - 2;
  let numeros = cnpj.substring(0, tamanho);
  let digitos = cnpj.substring(tamanho);
  let soma = 0;
  let pos = tamanho - 7;

  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  let resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(0))) return false;

  tamanho += 1;
  numeros = cnpj.substring(0, tamanho);
  soma = 0;
  pos = tamanho - 7;
  for (let i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--;
    if (pos < 2) pos = 9;
  }

  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11);
  if (resultado !== Number(digitos.charAt(1))) return false;

  return true;
}

export function validarCPF(cpf) {
  cpf = cpf.replace(/[^\d]+/g, '');

  if (cpf === '') return false;

  if (cpf.length !== 11) return false;

  if (/^(\d)\1{10}$/.test(cpf)) return false;

  let soma = 0;
  for (let i = 1; i <= 9; i++) {
    soma += parseInt(cpf.charAt(i - 1)) * (11 - i);
  }

  let resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(9))) return false;

  soma = 0;
  for (let i = 1; i <= 10; i++) {
    soma += parseInt(cpf.charAt(i - 1)) * (12 - i);
  }

  resto = (soma * 10) % 11;
  if (resto === 10 || resto === 11) resto = 0;
  if (resto !== parseInt(cpf.charAt(10))) return false;

  return true;
}

export function validarEmail(email) {
  const regexEmail = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/;
  return regexEmail.test(email);
}

export function validarTelefone(telefone) {
  const regexTelefone = /^\(?(\d{2})\)?\s?(\d{4,5})\s?-?\s?(\d{4})$/;
  return regexTelefone.test(telefone);
}

export function validarNome_(nome) {
  // Permite letras, espaços, apóstrofos, hífens e pontos
  const regexNome = /^[a-zA-ZÀ-ú\s.'-]+$/;
  return nome.length >= 3 && regexNome.test(nome);
}

export function validarNomeEmpresa_(nome) {
  // Permite letras, números, espaços e caracteres especiais comuns
  const regexNome = /^[a-zA-ZÀ-ú0-9\s.,&'\/+-]+$/;
  return nome.length >= 3 && regexNome.test(nome);
}


// ======================================================
// Helpers internos (não exportados)
// ======================================================

// Normaliza, aparas e comprime espaços internos
function _normalizeBase(str) {
  if (typeof str !== 'string') return '';
  return str.normalize('NFC').replace(/\s+/g, ' ').trim();
}

// Escapa caracteres para uso seguro em classe de regex
function _escapeForCharClass(chars) {
  return chars.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}

// Colapsa repetições dos especiais e remove especiais nas bordas
function _autoFixSpecials(s, specials) {
  if (!s) return s;
  const esc = _escapeForCharClass(specials);

  // 1) Colapsa repetições do MESMO especial: "--" => "-", "''" => "'"
  const collapseSameSpecial = new RegExp(`([${esc}])\\1+`, 'g');
  s = s.replace(collapseSameSpecial, '$1');

  // 2) Remove especial no início/fim
  const trimEdgeSpecials = new RegExp(`^[${esc}]+|[${esc}]+$`, 'g');
  s = s.replace(trimEdgeSpecials, '');

  // 3) Re-trim final
  return s.trim();
}

// Monta regex “super segura”
function _buildSafeRegex({ specials, allowNumbers = false }) {
  const esc = _escapeForCharClass(specials);
  const specialsClass = `[${esc}]`;
  const baseChars = allowNumbers ? `\\p{L}\\p{M}\\p{N}` : `\\p{L}\\p{M}`;
  // ^(?![special])(?!.*[special]$)(?!.*[special]{2})[base + special + espaço]+$
  return new RegExp(
    `^(?!${specialsClass})(?!.*${specialsClass}$)(?!.*${specialsClass}{2})[${baseChars}${esc} ]+$`,
    'u'
  );
}

// ======================================================
// Configurações
// ======================================================
const EMPRESA_SPECIALS = ".,&'/+-"; // + números
const PESSOA_SPECIALS  = ".-'";     // sem números

const REGEX_EMPRESA = _buildSafeRegex({ specials: EMPRESA_SPECIALS, allowNumbers: true });
const REGEX_PESSOA  = _buildSafeRegex({ specials: PESSOA_SPECIALS,  allowNumbers: false });

// Sanitizações específicas (internas)
function _sanitizeEmpresa(input) {
  let s = _normalizeBase(input);
  s = s.replace(/[‘’‛‚`´ˈˊ]/g, "'"); // normaliza apóstrofos “fancy” (se vierem)
  s = _autoFixSpecials(s, EMPRESA_SPECIALS + ' '); // trata espaço como “especial” para colapsar
  return s;
}

function _sanitizePessoa(input) {
  let s = _normalizeBase(input);
  s = s.replace(/[‘’‛‚`´ˈˊ]/g, "'"); // normaliza apóstrofos “fancy”
  s = _autoFixSpecials(s, PESSOA_SPECIALS + ' ');
  return s;
}

// ======================================================
// EXPORTS: validadores que já sanitizam internamente
// ======================================================

export function validarNomeEmpresa(input) {
  const s = _sanitizeEmpresa(input);
  return s.length >= 3 && REGEX_EMPRESA.test(s);
}

export function validarNome(input) {
  const s = _sanitizePessoa(input);
  return s.length >= 3 && REGEX_PESSOA.test(s);
}




// 8 ou 9 digits for phone
export const maskPhone = (valueRaw) => {

   let value = String(valueRaw).replace(/\D/g, ""); // convert to sdtring if number

	if (value.length <= 10) {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{2})(\d)/, "($1) $2")
		.replace(/(\d{4})(\d)/, "$1-$2")
		.replace(/(-\d{4})(\d+?)$/, "$1");
	} // end if
	else {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{2})(\d)/, "($1) $2")
		.replace(/(\d{5})(\d)/, "$1-$2")
		.replace(/(-\d{4})(\d+?)$/, "$1");		
	} // end else
};

// Credit Card Mask
export const maskCreditcard = (value) => {
	
	var startWith = value.slice(0, 2);
	
	// If Amex
	if ((startWith == "34" || startWith == "37") ) { 
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{4})(?=\d)?(\d{6})?(\d{5})/,"$1 $2 $3")	
	} // end if
	else {
	  return value
		.replace(/\D/g, "")
		.replace(/(\d{4})(?=\d)/, "$1 ")	  
		.replace(/(\d{4})(?=\d)/, "$1 ")
		.replace(/(\d{4})(?=\d)/, "$1 ")
		.replace(/(\d{4})(?=\d)/, "$1 ")
	} // end else
};

export const maskCPF = (value) => {
  return value
    .replace(/\D/g, "")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d)/, "$1.$2")
    .replace(/(\d{3})(\d{1,2})/, "$1-$2")
    .replace(/(-\d{2})\d+?$/, "$1");
};

export const maskCNPJ = (value) => {
  return value
    .replace(/\D+/g, '') 
    .replace(/(\d{2})(\d)/, '$1.$2') 
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1/$2') 
    .replace(/(\d{4})(\d)/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') 
};

export const Callto = ({ phone, style, children }) => {
  return <a href={`tel:${phone}`} style={style}>{children}</a>;
};

export const Whatsapp = ({ phone, style, children }) => {
  return <a href={`http://api.whatsapp.com/send?phone=${phone}`} style={style} target="_blank">{children}</a>;
  
};

export const extractRFBListData = (jsonData)  => {

  let porte = '';
  let situacao = '';
  let cnae = '';

  // Percorre o array de objetos JSON
  jsonData.forEach(item => {
    // Extrai os dados de acordo com a chave
    switch (item.key) {
      case 'porte':
        // Extrai a descrição do porte
        const porteMatch = item.value.match(/descricao: (.*)/);
        if (porteMatch) {
          porte = porteMatch[1];
        }
        break;
      case 'situacao':
        // Extrai o nome e a data da situação
        const situacaoMatch = item.value.match(/nome: (.*) \| data: (.*)/);
        if (situacaoMatch) {
          situacao = `${situacaoMatch[1]} desde ${situacaoMatch[2]}`;
        }
        break;
      case 'cnae':

          // Expressão regular para extrair o valor de fiscal e descrição
          const fiscalRegex = /fiscal: (\d+)/;
          const descricaoRegex = /descricao: (.+?) \|/;

          // Executa as expressões regulares para obter os valores
          const fiscalMatch = item.value.match(fiscalRegex);
          const descricaoMatch = item.value.match(descricaoRegex);

          // Verifica se houve correspondência e extrai os valores
          const fiscal = fiscalMatch ? fiscalMatch[1] : null;
          const descricao = descricaoMatch ? descricaoMatch[1] : null;      

        if (fiscal && descricao) {
          cnae = fiscal+ ' ('+descricao+')';
        }     
        break;
      default:
        break;
    }
  });

  // Retorna os dados extraídos
  return {
    porte,
    situacao,
    cnae
  };
}

// Função para extrair os valores desejados
export const extractCnae = (value) => {
	// Expressões regulares para capturar os campos específicos
	const regexPatterns = {
	  fiscal: /fiscal:\s*([\d]+)/,
	  divisao: /divisao:\s*([\d]+)/,
	  grupo: /grupo:\s*([\d.]+)/,
	  classe: /classe:\s*([\d.-]+)/,
	  subClasse: /subClasse:\s*([\d\/-]+)/,
	  descricao: /descricao:\s*([^\|]+)/
	};
  
	// Extrair os valores usando as expressões regulares
	const result = {};
	for (const [key, regex] of Object.entries(regexPatterns)) {
	  const match = value.match(regex);
	  result[key] = match ? match[1].trim() : "Não encontrado";
	}
  
	// Retornar a estrutura desejada
	return {
		divisao: result.divisao,
		grupo: result.grupo,
		classe: result.classe,
		subClasse: result.subClasse,
		fiscal: result.fiscal,
		descricao: result.descricao
	};
  }

export const extractSimplesNacional = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    optante: /optante:\s*([^|]+)/,
    inicio: /inicio:\s*([\d\/]+)/,
    fim: /fim:\s*([\d\/]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      optante: result.optante,
      inicio: result.inicio,
      fim: result.fim
  };
}

export const  extractMatrizEndereco = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    cep: /cep:\s*([\d-]+)/,
    tipo: /tipo:\s*([^|]+)/,
    logradouro: /logradouro:\s*([^|]+)/,
    numero: /numero:\s*([^|]+)/,
    complemento: /complemento:\s*([^|]+)/,
    bairro: /bairro:\s*([^|]+)/,
    cidade: /cidade:\s*([^|]+)/,
    uf: /uf:\s*([A-Z]{2})/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      cep: result.cep,
      tipo: result.tipo,
      logradouro: result.logradouro,
      numero: result.numero,
      complemento: result.complemento,
      bairro: result.bairro,
      cidade: result.cidade,
      uf: result.uf
  };
}

export const extractNaturezaJuridica = (value) => {
  // Expressões regulares para capturar os campos específicos
  const regexPatterns = {
    codigo: /codigo:\s*(\d+)/,
    descricao: /descricao:\s*([^|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      codigo: result.codigo,
      descricao: result.descricao
  };
} 

export const extractSituacao = (value) => {
  
  const regexPatterns = {
    id: /id:\s*(\d+)/,
    nome: /nome:\s*([^\|]+)/, // Ajuste aqui para capturar até o final da parte de nome
    data: /data:\s*([^\|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      id: result.id,
      nome: result.nome,
      data: result.data
  };

}

export const extractPorte = (value) => {
  // Expressões regulares para capturar os campos
  const regexPatterns = {
    id: /id:\s*(\d+)/,
    descricao: /descricao:\s*([^\|]+)/
  };

  // Extrair os valores usando as expressões regulares
  const result = {};
  for (const [key, regex] of Object.entries(regexPatterns)) {
    const match = value.match(regex);
    result[key] = match ? match[1].trim() : "Não encontrado";
  }

  // Retornar a estrutura desejada
  return {
      id: result.id,
      descricao: result.descricao
  };
}

export const formatCurrency = (value) => {

  var valorAlterado = value;
	valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
	valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
	valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos
	//valorAlterado = "€ " + valorAlterado;
	return valorAlterado;

}

export const formatNumberCurrency = (value,currency='EUR') => {
  return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: currency }).format(value);
}

export const formatCurrencyNoSymbol = (value) => {

  var valorAlterado = String(value);
	valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
	valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
	valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos
	valorAlterado = valorAlterado;
 
	return valorAlterado; 

}

export const formatCurrencyDecimals = (value) => {
  //if (!value) return '0,00';
  if (!value || value == '0,00') return '';

  // Garante que o valor é tratado como string e remove caracteres não numéricos
  let valorAlterado = String(value).replace(/\D/g, "");
  
  // Preenche com zeros à esquerda para garantir que haja pelo menos dois dígitos
  valorAlterado = valorAlterado.padStart(3, '0');
  
  // Extrai os centavos e a parte inteira
  const length = valorAlterado.length;
  const intPart = valorAlterado.slice(0, length - 2) || '0';
  const decimalPart = valorAlterado.slice(length - 2);
  
  // Formata a parte inteira com pontos de milhar, se necessário
  const formattedIntPart = parseInt(intPart).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  
  return `${formattedIntPart},${decimalPart}`;
};


export const formatCurrencyDecimalsWithLimit = (value,limit) => {
  //if (!value) return '0,00';
  if (!value || value == '0,00') return '';

    // Remove todos os caracteres não numéricos
    let valorAlterado = String(value).replace(/\D/g, "");
  
    // Preenche com zeros à esquerda para garantir que haja pelo menos dois dígitos
    valorAlterado = valorAlterado.padStart(3, '0');
  
    // Converte o valor alterado para número e checa o limite
    let numericValue = parseInt(valorAlterado, 10) / 100;
    if (numericValue > limit) {
      numericValue = limit;
    }
  
    // Converte o valor numérico de volta para string respeitando o formato de moeda
    valorAlterado = numericValue.toFixed(2).replace('.', ','); // Converte para string com duas casas decimais
    valorAlterado = valorAlterado.replace(/\B(?=(\d{3})+(?!\d))/g, "."); // Adiciona pontos a cada três dígitos
  
    return valorAlterado;
};




export const formatCurrencyNoSymbolLimit = (value, limit) => {
  var valorAlterado = String(value);
  valorAlterado = valorAlterado.replace(/\D/g, ""); // Remove todos os não dígitos
  valorAlterado = valorAlterado.replace(/(\d+)(\d{2})$/, "$1,$2"); // Adiciona a parte de centavos
  valorAlterado = valorAlterado.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1."); // Adiciona pontos a cada três dígitos

  // Converte para número e verifica se está dentro do limite
  let numericValue = parseFloat(valorAlterado.replace(/\./g, '').replace(',', '.'));
  if (numericValue > limit) {
    return limit.toFixed(2).replace('.', ',');
  }

  return valorAlterado;
}

export const formatCurrencyWithDecimal = (value) => {
  
  var texto = String(value);

  let valorNumerico = texto.replace(/[^0-9,]/g, "");

  // Converte vírgula para ponto para manipulação e depois reverte para o formato desejado
  //valorNumerico = valorNumerico.replace(",", ".");

  // Converte a string numérica para um número flutuante
  const numero = parseFloat(valorNumerico);

  // Verifica se o número é um NaN (não um número), se sim, retorna o original
  if (isNaN(numero)) return texto;

  // Formata o número com separadores de milhar e duas casas decimais
  let resultado = numero.toLocaleString('pt-BR', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
  });

  // Converte novamente ponto para vírgula para o formato brasileiro
  resultado = resultado.replace(/\./g, "#").replace(/,/g, ",").replace(/#/g, ".");

  // Retorna o texto original substituindo o valor numérico pelo valor formatado
  return texto.replace(valorNumerico.replace(",", "."), resultado);
}

export const formatValueNoDecimals = (value) => {

  // Converte o valor para string para garantir que podemos usar o método replace
  let valueStr = String(value);

  // Substitui vírgulas por pontos para uniformizar o formato decimal
  valueStr = valueStr.replace(',', '.');

  // Converte a string tratada para um número flutuante
  const floatValue = parseFloat(valueStr);

  // Verifica se a conversão resultou em um número válido
  if (isNaN(floatValue)) {
    throw new Error('Invalid number format');
  }

  // Multiplica o valor por 100 e arredonda para remover as casas decimais
  const multipliedValue = Math.round(floatValue * 100);

  return String(multipliedValue);

}

export const formatPercentageNumber = (data) => {
  const number = parseFloat(data);
  if (!isNaN(number)) {
      return number.toFixed(1).replace(".", ",")+"%";
  }
  return "Valor não numérico"; // ou outra manipulação de erro de acordo com sua lógica de negócio
}

export const isJsonString = (str) => {
  if (typeof str !== 'string') {
        return false; // Não é uma string
  }
  
  try { 
    // Verifica se o valor é um objeto ou um array
    if (str.trim().startsWith('{') && str.trim().endsWith('}') || str.trim().startsWith('[') && str.trim().endsWith(']')) {
        const parsed = JSON.parse(str);
        return (typeof parsed === 'object' && parsed !== null);
      } else {
        return true;
      }
      
  } catch (error) {
      return true; // Não é um JSON válido mas ainda é uma string
  }
}

export const toJsonOrEmpty = (str) => {
  if (typeof str !== 'string' || str === null) {
    console.log('NOT A STRING');
      return {}; // Retorna um JSON vazio para entradas não-string ou null
  }

  try {
      return JSON.parse(str); // Tenta converter a string para JSON
  } catch (error) {
      return str; // Retorna a string pois não é um json
  }
}

export function createDateAsLocal(dateString) {
  const date = new Date(dateString);
  const userTimezoneOffset = date.getTimezoneOffset() * 60000;
  return new Date(date.getTime() + userTimezoneOffset);
}


export function padronizarDecimal(numeroString) {

  // Converter a string para número
  let numero = parseFloat(numeroString);
  
  // Verificar se o número é inteiro
  if (Number.isInteger(numero)) {
      // Se for inteiro, adiciona uma casa decimal ".0"
      return `${numero}.0`;
  } else {
      // Se já tiver uma casa decimal, retorna como está
      return numero.toString();
  }
}


// Bloqueia o scroll da página (útil ao abrir modais)
export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

// Libera o scroll da página (útil ao fechar modais)
export const enableBodyScroll = () => {
  document.body.style.overflow = '';
};


export const validarDataNascimentoMinima = (date) => {
  try {
    const today = new Date();

    // Suporta "dd/mm/yyyy"
    const [dia, mes, ano] = date.split('/').map(Number);
    const birthDate = new Date(ano, mes - 1, dia);

    // Se a data for inválida ou futura, retorna false
    if (isNaN(birthDate.getTime()) || birthDate > today) {
      return false;
    }

    // Verifica diferença em milissegundos (1 dia = 86400000 ms)
    const diff = today - birthDate;
    return diff >= 86400000; // >= 1 dia
  } catch (e) {
    return false;
  }
}

export const aplicarMascaraDataNascimento = (valor) =>  {
   if (!valor) return '';

  let cleaned = valor.replace(/\D/g, '');

  let day = cleaned.substring(0, 2);
  let month = cleaned.substring(2, 4);
  let year = cleaned.substring(4, 8);

  // Validação do dia (01 a 31) apenas se tiver 2 dígitos
  if (day.length === 2) {
    let dayInt = parseInt(day, 10);
    if (dayInt === 0) day = '01';
    else if (dayInt > 31) day = '31';
  }

  // Validação do mês (01 a 12) apenas se tiver 2 dígitos
  if (month.length === 2) {
    let monthInt = parseInt(month, 10);
    if (monthInt === 0) month = '01';
    else if (monthInt > 12) month = '12';
  }

  // Validação do ano (até ano atual)
  if (year.length === 4) {
    const currentYear = new Date().getFullYear();
    let yearInt = parseInt(year, 10);
    if (yearInt > currentYear) year = String(currentYear);
  }

  let formatted = day;
  if (month) formatted += '/' + month;
  if (year) formatted += '/' + year;

  return formatted;
}

export const getAgeCategory = (birthDateStr) => {
  const today = new Date();
  const birthDate = new Date(birthDateStr);

  // Calcula a idade em anos
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDiff = today.getMonth() - birthDate.getMonth();
  const dayDiff = today.getDate() - birthDate.getDate();

  // Ajusta caso ainda não tenha feito aniversário no ano atual
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  // Determina a faixa etária
  if (age <= 2) {
    return 'baby';
  } else if (age >= 3 && age <= 12) {
    return 'child';
  } else if (age >= 13 && age <= 19) {
    return 'teenager';
  } else if (age >= 20 && age <= 59) {
    return 'adult';
  } else if (age >= 60) {
    return 'senior';
  } else {
    return 'unknown';
  }
}


export function getCardBrand(numero) {
  const clean = numero.replace(/\D/g, '');

  const brands = {
    visa: /^4[0-9]{12}(?:[0-9]{3})?$/,
    mastercard: /^5[1-5][0-9]{14}$/,
    amex: /^3[47][0-9]{13}$/,
    elo: /^(4011|4312|4389|4514|4576|5041|5066|5067|5090|6277|6362|6363|650|6516|6550)/,
    hipercard: /^606282|3841/,
    diners: /^3(?:0[0-5]|[68][0-9])[0-9]{11}$/,
    discover: /^6(?:011|5[0-9]{2})[0-9]{12}$/
  };

  for (const [bandeira, regex] of Object.entries(brands)) {
    if (regex.test(clean)) {
      return bandeira;
    }
  }

  return 'outros';
}


export function validarNumeroCartao(numero) {
  if (!numero) return true;

  const clean = numero.replace(/\D/g, '');
  const isValidLength = clean.length >= 13 && clean.length <= 19;
  const soma = clean
    .split('')
    .reverse()
    .map((d, i) => {
      let n = parseInt(d, 10);
      if (i % 2 === 1) {
        n *= 2;
        if (n > 9) n -= 9;
      }
      return n;
    })
    .reduce((acc, val) => acc + val, 0);

  return isValidLength && soma % 10 === 0;
}

export function validarNomeCartao(nome) {
  if (!nome) return true;

  const clean = nome.trim();

  // Remove múltiplos espaços
  const partes = clean.replace(/\s+/g, ' ').split(' ');

  if (partes.length < 2) return false; // Precisa ter pelo menos nome e sobrenome

  // Garante que pelo menos uma parte tenha mais de 1 letra (evita "J R")
  const partesValidas = partes.filter(p => p.length > 1);

  return partesValidas.length >= 2;
}

export function validarValidadeCartao(exp) {
  if (!exp) return true;
  
  const match = exp.match(/^(\d{2})\/?(\d{2,4})$/);
  if (!match) return false;

  let mes = parseInt(match[1], 10);
  let ano = parseInt(match[2], 10);

  if (mes < 1 || mes > 12) return false;
  if (ano < 100) {
    ano += 2000; // converte 2 dígitos para 4
  }

  const agora = new Date();
  const mesAtual = agora.getMonth() + 1;
  const anoAtual = agora.getFullYear();

  return ano > anoAtual || (ano === anoAtual && mes >= mesAtual);
}


export function maskCardExpiry_(value) {
  if (!value) return '';

  // Remove tudo que não for número
  let digits = value.replace(/\D/g, '').slice(0, 4); // até 4 números (MMYY)

  // Insere a barra automaticamente após os 2 primeiros dígitos
  if (digits.length >= 3) {
    return digits.slice(0, 2) + '/' + digits.slice(2);
  }

  return digits;
}

export function maskCardExpiry(value, validateDate = true) {
  if (!value) return { value: '', valid: false, message: null };

  const now = new Date();
  const currentMonth = now.getMonth() + 1; // 1..12
  const currentYearYY = now.getFullYear() % 100; // 0..99
  const currentYearTens = Math.floor(currentYearYY / 10); // dezena do ano atual
  const currentYearOnes = currentYearYY % 10;             // unidade do ano atual

  let digits = value.replace(/\D/g, '');
  let out = '';
  let digitError = false;
  let message = null;

  // 1) Primeiro dígito do mês: apenas 0 ou 1
  if (digits.length >= 1) {
    const d1 = digits[0];
    if (d1 === '0' || d1 === '1') {
      out += d1;
    } else {
      if (validateDate) message = 'O primeiro dígito do mês deve ser 0 ou 1.';
      digitError = true;
    }
  }

  // 2) Segundo dígito do mês
  if (digits.length >= 2 && out.length >= 1) {
    const d2 = digits[1];
    const d1 = out[0];
    if (d1 === '0') {
      // 01..09 (não permite 00)
      if (d2 >= '1' && d2 <= '9') {
        out += d2;
      } else {
        if (validateDate) message = 'Mês inválido. Se começar com 0, o segundo dígito deve ser de 1 a 9.';
        digitError = true;
      }
    } else if (d1 === '1') {
      // 10..12
      if (d2 >= '0' && d2 <= '2') {
        out += d2;
      } else {
        if (validateDate) message = 'Mês inválido. Se começar com 1, o segundo dígito deve ser 0, 1 ou 2.';
        digitError = true;
      }
    }
  }

  // 3) Primeiro dígito do ano (terceiro no total): deve ser >= dezena do ano atual
  if (digits.length >= 3) {
    const y1Char = digits[2];
    const y1 = parseInt(y1Char, 10);
    if (!Number.isNaN(y1) && y1 >= currentYearTens) {
      if (out.length === 2) out += '/'; // adiciona barra quando mês estiver completo
      out += y1Char;
    } else {
      if (validateDate) {
        message = `Ano inválido. O primeiro dígito do ano (YY) deve ser ${currentYearTens} ou maior.`;
      }
      digitError = true;
    }
  }

  // 4) Segundo dígito do ano (quarto no total): dinâmico conforme o ano atual
  if (digits.length >= 4) {
    const y2Char = digits[3];
    const y2 = parseInt(y2Char, 10);

    // Só podemos validar y2 se y1 foi aceito e já está em 'out'
    // Formatos possíveis neste ponto: "M", "MM", "MM/", "MM/Y"
    const hasYearTens =
      out.length >= 4 && out[2] === '/'; // "MM/Y"
    const y1Accepted = hasYearTens ? parseInt(out[3], 10) : null;

    if (y1Accepted !== null && !Number.isNaN(y2)) {
      let canAcceptY2 = false;
      if (y1Accepted > currentYearTens) {
        // qualquer 0..9 é válido
        canAcceptY2 = y2 >= 0 && y2 <= 9;
      } else if (y1Accepted === currentYearTens) {
        // precisa ser >= unidade do ano atual
        canAcceptY2 = y2 >= currentYearOnes && y2 <= 9;
      }

      if (canAcceptY2) {
        if (out.length === 3) {
          out += y2Char; // "MM/" -> "MM/Y"
        } else if (out.length === 4) {
          out += y2Char; // "MM/Y" -> "MM/YY"
        } else if (out.length === 5) {
          out = out.slice(0, 5) + y2Char; // defensivo
        }
      } else {
        if (validateDate) {
          message =
            y1Accepted === currentYearTens
              ? `Ano inválido. Para ${currentYearTens}_, o segundo dígito deve ser ${currentYearOnes} ou maior.`
              : 'Ano inválido.';
        }
        digitError = true;
      }
    } else {
      // Se não temos y1 aceito, apenas não adiciona y2
      if (validateDate && y1Accepted === null) {
        message = 'Informe primeiro o terceiro dígito (dezena) válido do ano.';
      }
      digitError = true;
    }

    // Validação final (MMYY completo) se habilitada
    if (validateDate && out.length >= 5) {
      const mm = parseInt(out.slice(0, 2), 10); // "MM"
      const yy = parseInt(out.slice(3, 5), 10); // "YY"

      const isMonthValid = mm >= 1 && mm <= 12;
      let isYearValid = true;

      if (yy === currentYearYY) {
        // mesmo ano: exige mês >= mês atual
        if (mm < currentMonth) {
          isYearValid = false;
          message = `Data expirada. Para ${String(yy).padStart(2, '0')}, o mês deve ser ${String(currentMonth).padStart(2, '0')} ou maior.`;
        }
      } else if (yy < currentYearYY) {
        isYearValid = false;
        message = 'Data expirada. O ano (YY) deve ser igual ou maior que o ano atual.';
      }

      const valid = isMonthValid && isYearValid;
      return { value: out, valid, message: valid ? null : message };
    }
  }

  // Se não completou MM/YY ou validação desativada
  return {
    value: out,
    digitError,
    valid: false, // ainda não é uma data completa e validada
    message,
  };
}

// apiErrorParser.js
export function parseUserCreateError(axiosError) {
  // quando cai no catch do axios
  const res = axiosError?.response;
  const data = res?.data || {};
  const status = res?.status;

  // default
  let title = 'Ops! Ocorreu um erro';
  let body = 'Não foi possível criar o usuário. Tente novamente.';
  const fieldErrors = {};   // para destacar campos
  let action = null;        // ex.: 'login' para redirecionar

  // auth
  if (status === 401 || data?.errorCode === '40101' || data?.errorCode === '40102') {
    title = 'Sessão expirada';
    body = 'Faça login novamente para continuar.';
    action = 'login';
    return { title, body, fieldErrors, action };
  }

  // parâmetros ausentes
  if (status === 400 && data?.errorCode === '40001') {
    title = 'Campos obrigatórios faltando';
    body = data?.errorMessage || 'Preencha os campos obrigatórios e tente novamente.';
    // tenta extrair nomes e marcar
    const missing = (data?.errorMessage || '').split(':')[1]?.split(',').map(s => s.trim()) || [];
    missing.forEach(k => {
      if (k.includes('person.fullName')) fieldErrors.nomeCompleto = 'Informe o nome completo';
      if (k.includes('person.cpf')) fieldErrors.cpf = 'Informe um CPF válido';
      if (k.includes('person.birthDate')) fieldErrors.nascimento = 'Informe a data de nascimento';
      if (k.includes('person.phone')) fieldErrors.celular = 'Informe um celular válido';
      if (k.includes('person.group')) fieldErrors.pessoaGrupo = 'Selecione o grupo';
      if (k.includes('user.profile')) fieldErrors.usuarioPerfil = 'Selecione o perfil';
      if (k.includes('user.email')) fieldErrors.email = 'Informe um e-mail válido';
      if (k.includes('user.password')) fieldErrors.senha = 'Defina a senha';
    });
    return { title, body, fieldErrors, action };
  }

  // parâmetros inválidos
  if (status === 400 && data?.errorCode === '40002') {
    title = 'Dados inválidos';
    body = data?.errorMessage || data?.errorContext || 'Revise os campos informados.';
    // heurísticas por mensagem
    const msg = (data?.errorMessage || '').toLowerCase();
    if (msg.includes('cpf')) fieldErrors.cpf = 'CPF inválido';
    if (msg.includes('email')) fieldErrors.email = 'E-mail inválido';
    if (msg.includes('telefone')) fieldErrors.celular = 'Telefone inválido';
    if (msg.includes('senha')) fieldErrors.senha = 'Senha inválida';
    if (msg.includes('nascimento') || msg.includes('data')) fieldErrors.nascimento = 'Data inválida';
    return { title, body, fieldErrors, action };
  }

  // companyId inválido
  if (status === 400 && data?.errorCode === '40003') {
    title = 'Agência inválida';
    body = 'Selecione uma agência válida antes de salvar.';
    fieldErrors.selectedCompany = 'Selecione a agência';
    return { title, body, fieldErrors, action };
  }

  // conflitos 409
  if (status === 409) {
    const conflict = data?.conflict;
    title = 'Conflito de dados';

    if (conflict === 'cpf' || data?.errorCode === '40901') {
      body = 'Já existe uma pessoa com este CPF cadastrada nesta agência.';
      fieldErrors.cpf = 'CPF já cadastrado';
      return { title, body, fieldErrors, action };
    }
    if (conflict === 'phone' || data?.errorCode === '40902') {
      body = 'Já existe uma pessoa com este telefone cadastrada nesta agência.';
      fieldErrors.celular = 'Telefone já cadastrado';
      return { title, body, fieldErrors, action };
    }
    if (data?.errorCode === '40903') {
      body = 'Já existe um usuário com este e-mail nesta agência.';
      fieldErrors.email = 'E-mail já cadastrado';
      return { title, body, fieldErrors, action };
    }
  }

  // 500 runtime
  if (status === 500 || data?.errorCode === '99999') {
    title = 'Erro interno';
    body = data?.errorContext
      ? `Falhou em: ${data.errorContext}`
      : 'Ocorreu um erro inesperado. Tente novamente.';
    return { title, body, fieldErrors, action };
  }

  // fallback
  return { title, body, fieldErrors, action };
}
